import { mapCollection } from '../../utils/collection.utils';
import { FilteredPollGroups } from '../filtered-poll-groups';
import { PollGroupBuilder } from './poll-group.builder';

export class FilteredPollGroupsBuilder {
    static fromJson(json) {
        return (json)
            ? new FilteredPollGroups(
                json.totalItems,
                PollGroupBuilder.fromList(json.pollGroups)
            )
            : null;
    }

    static fromList(list) {
        return (Array.isArray(list)) ? mapCollection(FilteredPollGroupsBuilder.fromJson, list) : [];
    }
}
